import React from 'react';

import { I18N_NAMESPACES } from 'i18n';
import { useTranslation } from 'i18n/hooks';
import { COMPANY_ROUTES } from 'routes';

import { Banner } from 'modules/common/components/Banner';

export const BlogJoinUsBanner = () => {
  const { tu } = useTranslation(I18N_NAMESPACES.BLOG);

  return (
    <Banner
      heading={tu('join-us-heading')}
      text={tu('join-us-text')}
      cta={tu('join-us-cta')}
      to={COMPANY_ROUTES.CONTACT_US}
    />
  );
};
